import Button from "components/base/Button";
import Page from "components/base/Page";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { FiDownload } from "react-icons/fi";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { download } from "utils/http";

function CustomFormPreview() {
  const { id: shipmentId } = useParams();
  const { state } = useLocation();
  const [generating, setGenerating] = useState("");

  if (!state) {
    return <Navigate to={`/shipment/shipments/${shipmentId}`} replace />;
  }

  const { shipment, requestData, html } = state;

  function generate(fileType) {
    setGenerating(fileType);
    const fallbackName = `Customform-SO${shipment.invoiceNumber.replace("/", "-")}`;
    download(
      `/shipment/${shipment.id}/custom-form/${fileType}/`,
      `${fallbackName}.${fileType}`,
      requestData,
      { useResponseFilename: true },
    )
      .catch((error) => Alert("error", String(error)))
      .finally(() => setGenerating(""));
  }

  return (
    <Page
      title="Preview Custom Form"
      backTo={`/shipment/shipments/${shipment.id}`}
      rightButtons={
        <div className="flex gap-6">
          <Button
            icon={<FiDownload />}
            loading={generating === "pdf"}
            onClick={() => generate("pdf")}
          >
            Generate PDF
          </Button>
          <Button
            icon={<FiDownload />}
            loading={generating === "xlsx"}
            onClick={() => generate("xlsx")}
          >
            Generate Excel
          </Button>
        </div>
      }
    >
      <div className="flex flex-col flex-1">
        <iframe
          title="Custom Form Preview"
          className="flex-1 w-full bg-white"
          srcDoc={html}
        />
      </div>
    </Page>
  );
}

export default CustomFormPreview;
